import axios from "axios";

export const handleUpload = (formData) => {
  return axios
    .post("https://muscatwhereto.com/api/v1/upload", formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error:", error);
      throw error; // Rethrow the error to be caught by the caller
    });
};
